import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import {
  Box,
  Dialog,
  DialogActionsProps,
  DialogProps,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { ReactNode } from "react";
import Flex from "./Flex";
import LoadingOverlay from "./LoadingOverlay";
import { ToastHost, TostController } from "./Toast";
import CustomTitle from "./app/CustomTitle";
import StyledButtonV2 from "./app/StyledButtonV2";

type DeleteModalProps<T> = {
  content: ReactNode;
  open: boolean;
  onClose: () => void;
  onConfirmation: (id?: T) => void;
  id?: T;
  h?: string;
  w?: string;
  dialogActionProps?: DialogActionsProps;
  cancelButtonText?: string;
  isLoading?: boolean;
  confirmButtonText?: string;
  title?: string;
  iconColor?: string;
  toastController?: TostController;
} & DialogProps;

/**
 * separate this modal similar like delete but with toast may be in future may requirement change
 * - to be safe to change this modal on status change
 *
 * @author rajkumar rathod
 */
const StatusModal = <T,>({
  content,
  open,
  onClose,
  onConfirmation,
  id,
  h: _h = "10vh",
  w = "10vw",
  dialogActionProps: _dialogActionProps,
  isLoading,
  title,
  cancelButtonText,
  confirmButtonText,
  iconColor: _iconColor,
  toastController,
  ...others
}: DeleteModalProps<T>) => {
  return (
    <Dialog open={open} maxWidth={"md"} {...others}>
      <Box pt={2} px={2}>
        {toastController && (
          <ToastHost
            toast={toastController.toast}
            onClose={toastController.closeToast}
          />
        )}
      </Box>

      <LoadingOverlay isLoading={isLoading ?? false} />

      {title && (
        <DialogTitle>
          <Box display="flex" justifyContent={"space-between"}>
            <Box display="flex">{title}</Box>
            <IconButton onClick={onClose}>
              <GridCloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
      )}
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        width={w}
      >
        {/* <WarningAmberRoundedIcon
          sx={{ fontSize: "4.2rem", color: iconColor ?? "red" }}
        /> */}

        <Flex
          mb={1}
          style={{
            padding: "10px",
            // border: `1px solid ${iconColor ?? "#d32f2f"}`,
            backgroundColor: "#FFF2F3",
            borderRadius: "50%",
          }}
          width={"fit-content"}
          mt={"12px"}
        >
          <WarningAmberRoundedIcon
            fontSize="large"
            sx={{
              color: "error.main",
              marginBottom: "2px",
            }}
          />
        </Flex>
        <CustomTitle size={18} color={"black"} bold>
          Are you sure?
        </CustomTitle>
        <Box my={"10px"} textAlign={"center"}>
          {content}
        </Box>
      </Flex>
      <Flex
        justifyContent={"center"}
        alignItems={"end"}
        p={2}
        gap={"20px"}
        width={"100%"}
      >
        <StyledButtonV2
          label={cancelButtonText ?? "No"}
          onClick={onClose}
          variant="outlined"
          fullWidth
        />

        <StyledButtonV2
          label={confirmButtonText ?? "Yes, Sure"}
          variant="contained"
          onClick={() => onConfirmation(id)}
          fullWidth
        />
      </Flex>
    </Dialog>
  );
};

export default StatusModal;
